import { render } from "./WarehouseParts.vue?vue&type=template&id=530b4768&scoped=true"
import script from "./WarehouseParts.vue?vue&type=script&lang=js"
export * from "./WarehouseParts.vue?vue&type=script&lang=js"

import "@/styles/warehouse.css?vue&type=style&index=0&id=530b4768&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530b4768"]])

export default __exports__